import { Link } from "react-router-dom";
import { BookOpen, FileCheck2, FileText, Users, MessagesSquare, Building2, ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading, Accent } from "@/components/Reveal";
import { IMAGES } from "@/lib/content";
import { useLang } from "@/lib/i18n";
import { getServiceById } from "@/lib/servicePages";
import { scrollToId } from "@/lib/api";

const ICONS = {
  abonament: BookOpen,
  godishno: FileCheck2,
  otcheti: FileText,
  zaplati: Users,
  registracia: Building2,
  konsultacii: MessagesSquare,
};

export const Services = () => {
  const { t, c } = useLang();
  return (
  <section id="services" data-testid="services-section" className="relative py-24 md:py-36 bg-coal/40">
    <div
      className="absolute inset-0 opacity-[0.07] pointer-events-none"
      style={{ backgroundImage: `url(${IMAGES.team})`, backgroundSize: "cover", backgroundPosition: "center" }}
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-6 md:px-10">
      <SectionHeading kicker={t.services.kicker} title={<Accent parts={t.services.title} />} testid="services-heading" />

      <div className="grid md:grid-cols-6 gap-6 md:gap-8">
        {c.SERVICES.map((s, i) => {
          const Icon = ICONS[s.id];
          return (
            <Reveal key={s.id} delay={i * 0.06} className={s.span}>
              <article
                data-testid={`service-card-${s.id}`}
                className={`group h-full border p-8 md:p-10 flex flex-col justify-between transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1 ${
                  s.isCta
                    ? "border-gold/50 bg-gold/[0.06] hover:shadow-[0_0_60px_-15px_rgba(203,163,101,0.35)]"
                    : "border-line bg-ink/80 backdrop-blur-sm hover:border-gold/40 hover:shadow-[0_0_60px_-20px_rgba(203,163,101,0.3)]"
                }`}
              >
                <div>
                  {Icon && <Icon size={26} className="text-gold mb-6" strokeWidth={1.5} />}
                  <h3 className="font-serif text-2xl md:text-3xl text-mist mb-3 leading-tight">{s.title}</h3>
                  <p className="text-dim text-sm md:text-base leading-relaxed mb-4">{s.short}</p>
                  {s.text && <p className="text-dim/70 text-sm leading-relaxed">{s.text}</p>}
                </div>
                <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3">
                  {!s.isCta && (
                    <Link
                      to={`/uslugi/${getServiceById(s.id).slug}`}
                      data-testid={`service-link-${s.id}`}
                      className="inline-flex items-center gap-2 text-sm tracking-wide text-gold hover:text-gold-light transition-colors duration-300"
                    >
                      {t.services.more}
                      <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                  )}
                  <button
                    data-testid={`service-cta-${s.id}`}
                    onClick={() => scrollToId("#contact")}
                    className={`inline-flex items-center gap-2 text-sm tracking-wide transition-colors duration-300 ${
                      s.isCta ? "text-gold hover:text-gold-light" : "text-dim hover:text-mist"
                    }`}
                  >
                    {s.isCta ? t.services.contact : t.services.ask}
                    <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </button>
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};
